function toCopyableText(children) {
	if (typeof children === 'string') return children
	else if (Array.isArray(children)) return children.map(toString).join(' ')

	return toString(children.props?.children || '')
}

export default toCopyableText
